import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Container } from "@material-ui/core";
import { Button } from "../components/ui/forms/Button";
import Header from "../components/layout/Header/Header";
import Footer from "../components/layout/Footer";
import Pane from "../components/layout/Pane/Pane";
import Tabs from "../components/layout/Pane/Tabs";
import Spinner from "../components/ui/Spinner";
import { Typography } from "@material-ui/core";
import { UserSettingsPage } from "./Settings/UserSettingsPage";
import { CardSettingsPage } from "./Settings/CardSettingsPage";

import { UserContext } from "../contexts/UserContext";
import { PaneContext } from "../contexts/PaneContext";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import PersonIcon from "@material-ui/icons/Person";
import { SubHeading } from "../components/ui/SubHeading";
import SettingsIcon from "@material-ui/icons/Settings";

const Settings = () => {
  const [loading, setLoading] = useState(false);
  const { changeTab } = useContext(PaneContext);
  const { id, Site, updateSite } = useContext(UserContext);
  const navigate = useNavigate();

  const handleSave = async () => {
    setLoading(true);
    await updateSite(Site.siteCode, Site);
    setLoading(false);
  };

  useEffect(() => {
    changeTab(0);
    //eslint-disable-next-line
  }, []);

  return id ? (
    <PageContainer>
      <Header />
      <Container>
        <SettingsPane
          variant="settings"
          subHeader={
            <Typography style={Tstyles}>
              <SettingsIcon style={iconStyles1} /> Settings
            </Typography>
          }
        >
          <Tabs
            data={[
              {
                index: 0,
                title: (
                  <Typography style={Tstyles}>
                    {" "}
                    <CreditCardIcon style={iconStyles} /> Cards
                  </Typography>
                ),
                //icon: CreditCardIcon,
                component: <CardSettingsPage />,
              },
              {
                index: 1,
                title: (
                  <Typography style={Tstyles}>
                    {" "}
                    <PersonIcon style={iconStyles} /> User & Site
                  </Typography>
                ),
                //icon: PersonIcon,
                component: <UserSettingsPage />,
              },
            ]}
          />

          <Actions>
            <Button onClick={handleSave} colour="success">
              {loading ? <Spinner colour="success" /> : "Save Settings"}
            </Button>
          </Actions>
        </SettingsPane>
      </Container>
      <Footer />
    </PageContainer>
  ) : (
    navigate("/login", { replace: true })
  );
};

const iconStyles = {
  fontSize: "18px",
};

const iconStyles1 = {
  fontSize: "16px",
};

const Tstyles = {
  fontWeight: "Bold",
  fontSize: "16px",
};

const PageContainer = styled.main`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SettingsPane = styled(Pane)`
  margin-top: 4rem;
`;

const Actions = styled.div`
  padding: 2rem;
`;

export default Settings;
